export const CHANGE_BRAND = {
  title: 'Tienes un proceso empezado',
  description: 'Si cambias de Marca ahora no se guardará lo que hayas hecho. ¿Deseas continuar?',
  actions: {
    continue: 'continuar',
    cancel: 'cancelar',
  },
}
export const CANCEL_SALE = {
  title: '¿Estás seguro que quieres Cancelar la venta?',
  description: 'Si cancelas se borrará todo lo que has hecho hasta ahora. ¿Deseas continuar?',
  actions: {
    continue: 'Sí, cancelar venta',
    cancel: 'No, continuar venta',
  },
}

export const RESTART_SALE = {
  title: 'Si vuelves a la pantalla anterior se cancelará la venta actual',
  description: 'Los datos que hayas introducido hasta ahora no se guardarán. ¿Deseas continuar?',
  actions: {
    continue: 'Continuar',
    cancel: 'Cancelar',
  },
}

export const EXIT_SALE = {
  title: 'Si vuelves a +Care se cancelará la venta actual',
  description: 'Los datos que hayas introducido hasta ahora no se guardarán. ¿Deseas continuar?',
  actions: {
    continue: 'Volver a +Care',
    cancel: 'Cancelar',
  },
}

export const BUNDLE_ERROR = {
  title: 'Error',
  description:
    'Ha sucedido un error inesperado y no se han podido recuperar los bonos, por favor inténtalo de nuevo.',
  actions: {
    retry: 'Probar de nuevo',
  },
}

export const CHECKOUT_MAINLINE_ERROR = {
  title: 'No se ha podido crear el pedido',
  description:
    'Es necesario crear el pedido para obtener el número de contrato. Por favor, inténtelo de nuevo.',
  actions: {
    retry: 'Probar de nuevo',
  },
}

export const CHECKOUT_ERROR = {
  title: 'No es posible dar de alta esta línea',
  actions: {
    exit: 'Salir',
  },
}

export const PRECONTRACT_SUCCESS = {
  title: 'Se he enviado correctamente la información precontractual',
  actions: {
    continue: 'Continuar',
  },
}

export const PRECONTRACT_ERROR = {
  title: 'No se ha podido enviar la información precontractual',
  actions: {
    continue: 'Continuar',
  },
}

export const PRECONTRACT_LOADING = {
  title: 'Estamos enviando la información precontractual del cliente',
  description: 'Una vez finalice el proceso de envío de información, puede continuar con la venta',
}

export const INVALID_QUERY_PARAMS = {
  title: 'No es posible recuperar los datos de cliente',
  description: 'Faltan parámetros para obtenerla. Por favor, continue la venta como cliente nuevo',
  actions: {
    continue: 'Continuar',
  },
}

export const NO_BRAND = {
  title: 'No dispones de una marca seleccionada',
  description: 'Por favor, selecciona la marca en el menú para continuar con la venta',
  actions: {
    continue: 'Continuar',
  },
}
export const CLIENT_SEARCH_INVALID_CONTRACT = {
  title: 'El contrato seleccionado es inválido',
  description: 'Por favor, inicie una venta nueva para este cliente',
  actions: {
    continue: 'Continuar',
  },
}

export const CLIENT_SEARCH_WITHOUT_CLIENT = {
  title: 'No se ha encontrado datos del cliente seleccionado',
  description: 'Por favor, continue la venta como cliente nuevo',
  actions: {
    continue: 'Continuar',
  },
}

export const CLIENT_SEARCH_SERVICE_ERROR = {
  title: 'No se ha podido recuperar los datos de cliente',
  description:
    'Es necesario obtener los datos de cliente para continuar la venta. Por favor, inténtelo de nuevo',
  actions: {
    retry: 'Probar de nuevo',
  },
}

export const CLIENT_SEARCH_SERVICE_ERRONEOUS_PARAMS = {
  title: 'No es posible recuperar los datos de cliente',
  description:
    'Los parámetros para obtener los datos son erróneos. Por favor, continue la venta como cliente nuevo',
  actions: {
    continue: 'Continuar',
  },
}

export const CLIENT_SEARCH_SERVICE_LOADING = {
  title: 'Espera un momento mientras obtenemos la información del cliente',
  description:
    'Una vez finalice el proceso de obtención de información, puede continuar con la venta',
}
